import { useEffect, useState } from 'react';

import { useCompanyCloseMutation } from '~hooks/query/admin/useCompanyPreference';
import useGetCompanyStates from '~hooks/query/company/useCompanyStates';
import { useRouterQuery } from '~hooks/useRouterQuery';

import ButtonAdmin from '../ButtonAdmin';
import Row from '../Row';
import { convertDateToFormattedStr, convertDateToISODate } from './helper';
import * as S from './style';

export default function RowClosing() {
  const [closedAt, setClosedAt] = useState<string>();
  const companyId = useRouterQuery('companyId');
  const { data: originCompanyStates } = useGetCompanyStates(companyId);
  const { mutate: handleClosing } = useCompanyCloseMutation();

  const handleClick = () => {
    if (!closedAt) {
      // TODO: Modal 적용
      alert('날짜를 입력해주세요');

      return;
    }

    handleClosing({
      closedAt: convertDateToISODate(closedAt),
    });
  };

  useEffect(() => {
    if (originCompanyStates) {
      setClosedAt(convertDateToFormattedStr(originCompanyStates.closedAt as string));
    }
  }, [originCompanyStates]);

  return (
    <Row title={'폐업 처리'} alignItems='flex-start'>
      <S.WrapperCalendar>
        <S.Input
          placeholder='연도 - 월 - 일'
          type='date'
          value={closedAt}
          disabled={originCompanyStates?.closed}
          onChange={(e) => {
            setClosedAt(e.target.value);
          }}
        />
        <S.Disclaimer disabled={originCompanyStates?.closed}>(폐업처리 시 입력 필수)</S.Disclaimer>
      </S.WrapperCalendar>
      <ButtonAdmin onClick={handleClick} disabled={originCompanyStates?.closed}>
        완료
      </ButtonAdmin>
    </Row>
  );
}
